import PropTypes from 'prop-types';

import Form from '@gef-ui/form-material/Form';

import formDescriptorFn, { SUBORDINATE_USERS_FORM_NAME } from 'features/views/usersSubordinate/form';

import FilterForm from './Form';

export const Filter = ({ resettingSubordinateUsersOnly, setResettingSubordinateUsersOnly }) => {
	return (
		<Form name={SUBORDINATE_USERS_FORM_NAME} formDescriptorFn={formDescriptorFn}>
			<FilterForm
				resettingSubordinateUsersOnly={resettingSubordinateUsersOnly}
				setResettingSubordinateUsersOnly={setResettingSubordinateUsersOnly}
			/>
		</Form>
	);
};

Filter.propTypes = {
	resettingSubordinateUsersOnly: PropTypes.bool,
	setResettingSubordinateUsersOnly: PropTypes.func,
};

export default Filter;
